import React, { useCallback } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import t from '@rcm/i18n-client';
import { clearSkusSelected } from '../../slices/skusSelected';

const ClearSkusSelectedButton = () => {
    const dispatch = useDispatch();

    const handleClearClick = useCallback(() => {
        dispatch(clearSkusSelected());
    }, []);

    return <Button variant="secondary" onClick={handleClearClick}>
        {t('Clear')}
    </Button>;

}

export default ClearSkusSelectedButton;
